import React, { useEffect, useState } from "react";
import {
  collection,
  query,
  where,
  onSnapshot,
  updateDoc,
  doc,
  writeBatch,
  Timestamp,
} from "firebase/firestore";
import { db } from "../firebase";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Grid,
  Modal,
  TextField,
  Alert,
} from "@mui/material";
import { jsPDF } from "jspdf";

const styleModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "white",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

const generateRandomNumber = () => Math.floor(1000 + Math.random() * 9000);

export default function Revisionrifa() {
  const [usuarios, setUsuarios] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [ticketCount, setTicketCount] = useState("");
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  // 🔥 Cargar usuarios pendientes
  useEffect(() => {
    const ref = collection(db, "granRifa");
    const q = query(ref, where("isApproved", "==", false));

    const unsubscribe = onSnapshot(q, (snap) => {
      const arr = [];
      snap.forEach((doc) => arr.push({ id: doc.id, ...doc.data() }));
      arr.sort((a, b) => b.purchaseDate?.seconds - a.purchaseDate?.seconds);
      setUsuarios(arr);
    });

    return () => unsubscribe();
  }, []);

  // 🔥 Cambiar estado a TRUE
  const aprobarPago = async (id) => {
    await updateDoc(doc(db, "granRifa", id), { isApproved: true });
  };

  // 🔥 Función para generar PDF
  const generateMultipleTickets = async (ticketsData) => {
    const docPdf = new jsPDF({ orientation: "landscape", unit: "px", format: [400, 200] });

    const primaryColor = "#003366";
    const accentColor = "#FFD700";
    const textColor = "#FFFFFF";
    const darkTextColor = "#333333";
    const currentDate = new Date().toLocaleDateString("es-ES");

    ticketsData.forEach((ticket, i) => {
      const participantName = ticket.username;
      const ticketNumber = ticket.ticket;
      const ticketCode = ticket.code;

      docPdf.setFillColor(primaryColor);
      docPdf.rect(0, 0, 400, 200, "F");

      docPdf.setFillColor("#004d99");
      docPdf.rect(0, 0, 400, 100, "F");

      docPdf.setDrawColor(accentColor);
      docPdf.setLineWidth(4);
      docPdf.rect(5, 5, 390, 190);

      docPdf.setFillColor(textColor);
      docPdf.roundedRect(20, 20, 360, 160, 8, 8, "F");

      docPdf.setDrawColor(primaryColor);
      docPdf.setLineWidth(2);
      docPdf.roundedRect(20, 20, 360, 160, 8, 8, "S");

      docPdf.setFont("helvetica", "bold");
      docPdf.setFontSize(24);
      docPdf.setTextColor(primaryColor);
      docPdf.text("Gran Rifa Consultante", 200, 50, { align: "center" });

      docPdf.setFontSize(14);
      docPdf.setFont("helvetica", "normal");
      docPdf.setTextColor(darkTextColor);
      docPdf.text("¡Gana 50,000 pesos!", 200, 70, { align: "center" });

      docPdf.setDrawColor(accentColor);
      docPdf.setLineWidth(1);
      docPdf.line(50, 85, 350, 85);

      docPdf.setFontSize(12);
      docPdf.text(`Participante:`, 50, 110);
      docPdf.setFont("helvetica", "bold");
      docPdf.text(`${participantName}`, 120, 110);

      docPdf.setFont("helvetica", "normal");
      docPdf.text(`Boleto Nº:`, 50, 125);
      docPdf.setFont("helvetica", "bold");
      docPdf.text(`${ticketNumber}`, 110, 125);

      docPdf.setFont("helvetica", "normal");
      docPdf.text(`Fecha:`, 50, 140);
      docPdf.setFont("helvetica", "bold");
      docPdf.text(`${currentDate}`, 120, 140);

      docPdf.setFillColor(primaryColor);
      docPdf.roundedRect(250, 100, 110, 60, 5, 5, "F");

      docPdf.setFont("helvetica", "bold");
      docPdf.setFontSize(12);
      docPdf.setTextColor(textColor);
      docPdf.text("CÓDIGO", 305, 115, { align: "center" });

      docPdf.setFontSize(32);
      docPdf.setTextColor(accentColor);
      docPdf.text(`${ticketCode}`, 305, 145, { align: "center" });

      if (i < ticketsData.length - 1) docPdf.addPage();
    });

    docPdf.save(`Boletos_${ticketsData[0].username}.pdf`);
  };

  // 🔥 Guardar boletos
  const guardarBoletos = async () => {
    if (!ticketCount || !selectedUser) return;

    const count = parseInt(ticketCount);
    if (isNaN(count) || count <= 0) {
      setError("La cantidad debe ser mayor a 0");
      return;
    }

    const batch = writeBatch(db);
    const colRef = collection(db, "granRifa");
    const purchaseTime = Timestamp.fromDate(new Date());

    const ticketsData = [];
    for (let i = 0; i < count; i++) {
      const data = {
        username: selectedUser.username,
        ticket: i + 1,
        purchaseDate: purchaseTime,
        code: generateRandomNumber(),
        isApproved: true,
        bankId: selectedUser.bankId || "",
      };
      const docRef = doc(colRef);
      batch.set(docRef, data);
      ticketsData.push(data);
    }

    await batch.commit();
    await generateMultipleTickets(ticketsData);

    setSuccess("Boletos generados correctamente");
    setTicketCount("");
    setOpenModal(false);
  };

  return (
    <Box p={3}>
      <Typography variant="h5" fontWeight="bold" mb={2}>
        Revisión de Pagos Pendientes
      </Typography>

      {usuarios.length === 0 && <Alert severity="info">No hay pagos pendientes.</Alert>}

      <Grid container spacing={2}>
        {usuarios.map((u) => (
          <Grid item xs={12} md={6} lg={4} key={u.id}>
            <Card>
              <CardMedia component="img" height="180" image={u.proofUrl} />
              <CardContent>
                <Typography><b>Usuario:</b> {u.username}</Typography>
                <Typography><b>Banco ID:</b> {u.bankId}</Typography>
                <Typography><b>Fecha:</b> {new Date(u.purchaseDate?.seconds * 1000).toLocaleString()}</Typography>
                <Typography><b>Aprobado:</b> {u.isApproved ? "Sí" : "No"}</Typography>

                <Button
                  fullWidth
                  variant="contained"
                  sx={{ mt: 1 }}
                  onClick={() => aprobarPago(u.id)}
                >
                  Aprobar Pago
                </Button>

                <Button
                  fullWidth
                  variant="outlined"
                  sx={{ mt: 1 }}
                  onClick={() => {
                    setSelectedUser(u);
                    setOpenModal(true);
                  }}
                >
                  AGREGAR BOLETOS
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* MODAL */}
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box sx={styleModal}>
          <Typography variant="h6" fontWeight="bold">
            Agregar boletos a {selectedUser?.username}
          </Typography>

          {success && <Alert severity="success" sx={{ mt: 2 }}>{success}</Alert>}
          {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}

          <TextField
            label="Cantidad de boletos"
            fullWidth
            sx={{ mt: 2 }}
            value={ticketCount}
            onChange={(e) => setTicketCount(e.target.value)}
            type="number"
          />

          <Button variant="contained" fullWidth sx={{ mt: 2 }} onClick={guardarBoletos}>
            Generar
          </Button>
        </Box>
      </Modal>
    </Box>
  );
}
